module.exports = __webpack_public_path__ + "img/lou_grotta.97d8b666.jpg";